export const LICENSE_PLATE_SUBMIT_MESSAGES = {
    missingPlateConfig: 'The license plate form is missing required field configuration for license plate or state.',
    missingEligibilityConfig:
        'The license plate form is missing required field configuration for first name, last name, or zip code.',
    missingBaseUrl: (countryCode: string) =>
        `Missing microservices base URL for ${countryCode.toUpperCase()}. Check the runtime configuration for the active environment.`,
    vehicleLookupFailed: 'Unable to find a vehicle for that license plate. Please verify your details and try again.',
    deviceValidationFailed: 'Unable to validate the vehicle for that license plate. Please try again.',
    accountLookupFailed: 'Unable to retrieve account information for that vehicle. Please try again.',
    deviceInfoFailed: 'Unable to retrieve vehicle information for that radio. Please try again.',
    systemError: 'Something went wrong while checking that license plate. Please try again.',
} as const;
